const PROVIDER_BASE_ROUTE = '/prestador';
const LOGIN_BASE_ROUTE = '/login';
const FORGOT_PW_ROUTE = '/forgot-password';

function mountRoute(route: string, prefix: string = PROVIDER_BASE_ROUTE): string {
  return `${prefix}${route}`;
}

export const FOUNDATION_ROUTES = {
  CONFIRM_USER: '/confirmar-usuario/:hash',
  CONFIRM_USER_FAIL: '/falha-confirmar-usuario',
  CONFIRM_USER_NEW_PW: '/confirmar-usuario/:hash/nova-senha',
  DASHBOARD: mountRoute('/dashboard'),
  FORGOT_PW: mountRoute('/redefinir-senha', LOGIN_BASE_ROUTE),
  HOME: '/prestador',
  LOGIN: mountRoute('', LOGIN_BASE_ROUTE),
  OPENID_CONNECT_CALLBACK: '/sso-callback',
  NEW_PW: '/nova-senha/:hash',
  RENEW_PW: '/login/renovar-senha/:nrSeqWSuiteUser',
  SSO_CALLBACK: '/sso-callback',
  SSO_ERROR_ROUTE: '/login-invalido',
};

export const Route = {
  ACTION_PLAN: mountRoute('/plano-acao'),
  ACTION_PLAN_DETAILS: mountRoute('/plano-acao/:nrSeqActionPlan/detalhes'),
  ACTION_PLAN_NEW: mountRoute('/plano-acao/novo'),
  CALLS: mountRoute('/chamados'),
  CALL: mountRoute('/chamados/:nrSeqCall'),
  CALL_DETAIL: mountRoute('/chamados/:nrSeqCall/detalhes'),
  CHANGE_PW: mountRoute('/meus-dados/alterar-senha'),
  CNES_SEARCH: mountRoute('/consulta-cnes'),
  CNES_SEARCH_DETAIL: mountRoute('/consulta-cnes/:nrSeqCnesSearch'),
  CONTRACTS: mountRoute('/contratos'),
  CONTRACT_DETAILS: mountRoute('/contratos/:nrSeqContract/detalhes'),
  DOCUMENTS: mountRoute('/documentos'),
  DOCUMENTS_DETAILS: mountRoute('/documentos/:nrSeqDocumentType'),
  NEW_CALL: mountRoute('/chamados/tipo-solicitacao/:nrSeqCategory/novo'),
  MESSAGES: mountRoute('/mensagens'),
  MESSAGE_DETAILS: mountRoute('/mensagens/:nrSeqCommunication/detalhes'),
  MY_DATA: mountRoute('/meus-dados'),
  NEGOTIATION: mountRoute('/historico-negociacoes'),
  NEGOTIATION_DETAILS: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation'),
  NEGOTIATION_PROPOSAL: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/negociacao-valores'),
  NEGOTIATION_PROPOSAL_DRAFT: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/minuta-contratual'),
  NEGOTIATION_CONTRACTUAL_AMENDMENT: mountRoute('/historico-negociacoes/negociacao/:nrSeqNegotiation/proposta/:nrSeqProposal/aditamento'),
  PRIVACY: mountRoute('/privacidade'),
  TECHNICAL_VISIT: mountRoute('/visita-tecnica'),
  TECHNICAL_VISIT_DETAILS:  mountRoute('/visita-tecnica/:nrSeqVisit'),
  FORM_TECHNICAL_VISIT: mountRoute('/formulario-visita-tecnica'),
  TASKS:  mountRoute('/tarefas'),
  TASK_DETAILS: mountRoute('/tarefas/:nrSequenceTask/detalhes'),
  TECHNICAL_VISIT_APPOINTMENTS:  mountRoute('/visita-tecnica/:nrSeqVisit/agendamentos'),
  TECHNICAL_VISIT_FORMS:  mountRoute('/visita-tecnica/:nrSeqVisit/formularios/:nrSeqForm'),
  TECHNICAL_VISIT_INCONSISTENCIES:  mountRoute('/visita-tecnica/:nrSeqVisit/inconsistencias'),
  CALL_CATEGORY: mountRoute('/chamados/tipo-solicitacao'),
  ACCREDITATION_UPDATE: mountRoute('/atualizacao-credenciamento'),
  ACCREDITATION_UPDATE_CATEGORIES: mountRoute('/atualizacao-credenciamento/nova-atualizacao'),
  ACCREDITATION_UPDATE_SIDEBAR_MENU: mountRoute('/atualizacao-credenciamento/:nrSeqAccreditation/tipo-credenciamento/:nrSeqTypeAccreditation'),
  INDICATORS: mountRoute('/indicadores'),
  INDICATOR_DETAILS: mountRoute('/indicadores/:nrSeqProviderIndicator/detalhes'),
  MEETING_MINUTES_CONSULTATION: mountRoute('/consulta-atas'),
  MEETING_MINUTE_DETAILS: mountRoute('/consulta-atas/:nrSeqProviderMeetingMinute'),
  REPORTS: mountRoute('/relatorios'),
};

export const BaseRoute = {
  INACTIVITY: '/inatividade',
  FORGOT_PW: FORGOT_PW_ROUTE,
};
